module.exports = __webpack_public_path__ + "static/media/vs-code.e379a736.png";